import { connect } from 'react-redux'
import New from './new'
import { create, fetchContract, lookup, resetFlags } from '../../actions'


const mapStateToProps = ({ settings, requestRucSummary = {} }) => ({
  fleetIds: settings.fleet.selected,
  relatedContract: requestRucSummary.related,
  fetchContractStatus: requestRucSummary.flags?.fetchContract || 'none',
  saveStatus: requestRucSummary.flags?.create || 'none',
  errorMessage: requestRucSummary.errorMessage,
  userRoles: settings.roles,
})

const mapDispatchToProps = (dispatch) => ({
  onFetchContract: (rego, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetchContract(null, {
      resourceId: rego,
      queryParams: { FleetId }
    }))
  },
  onSave: (payload) => {
    dispatch(create(payload))
  },
  onLookup: (lookupPath, searchKey, customFleetId) => {
    dispatch(lookup(null, {
      resourceId: lookupPath,
      queryParams: { FleetId: customFleetId, Search: searchKey }
    }))
  },
  onReset: () => {
    dispatch(resetFlags())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(New)
